import * as React from 'react';
import chroma from 'chroma-js';

const Bos = ({ mainColor, secColor }) => {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 351.21 351.21"
      height={200}
      width={200}
    >
      <defs>
        <mask id="maskRounded">
          <rect width="100%" height="100%" rx="20" ry="20" fill="white" />
        </mask>
        <radialGradient
          id="Gradient1"
          cx="301.71"
          cy="309.46"
          r="174.24"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor={mainColor} stopOpacity="0.7" />
          <stop offset="0.8" stopColor={mainColor + '00'} stopOpacity="0" />
          <stop offset="1" stopColor={'#fff'} stopOpacity="0" />
        </radialGradient>

        <radialGradient
          id="Gradient2"
          cx="124.2"
          cy="371.39"
          r="184.24"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor={secColor} stopOpacity="0.7" />
          <stop offset="0.8" stopColor={secColor + '00'} stopOpacity="0" />
          <stop offset="1" stopColor={'#fff'} stopOpacity="0" />
        </radialGradient>
      </defs>
      <g mask="url(#maskRounded)">
        <g>
          <rect fill="#f7f7f7" x={-34.88} y={-31.44} width={418} height={418} />
          <circle cx={301.71} cy={309.46} r={154.24} fill="url(#Gradient1)" />
          <rect
            fill="#FFF"
            x={29.47}
            y={29.02}
            width={226.09}
            height={175.36}
            rx={13.33}
            ry={13.33}
          />
          <path
            fill="#eaeaea"
            d="M29.47,52.43h65.22v151.95h-51.91c-7.34,0-13.31-5.96-13.31-13.31V52.43h0Z"
          />
          <circle className="cls-5" cx={41.68} cy={41.52} r={2.54} />
          <circle className="cls-8" cx={50.66} cy={41.52} r={2.54} />
          <circle className="cls-10" cx={59.54} cy={41.52} r={2.54} />
          <circle fill="#FFFFFF00" cx={124.2} cy={371.39} r={154.24} />
        </g>
        <circle cx={124.2} cy={371.39} r={154.24} fill="url(#Gradient2)" />
        <circle fill={mainColor} cx={254.21} cy={187.44} r={39.24} />
        <rect
          fill={'#FFF'}
          x={247.85}
          y={179.49}
          width={27.76}
          height={27.76}
          opacity={0.69}
          rx={5.34}
          ry={5.34}
        />
        <path
          fill={'#FFF'}
          d="M242.95,168.27c5.78,3.56,11.56,7.11,17.34,10.67,2.64,1.63,2.68,5.46.07,7.14l-17.42,11.22c-2.81,1.81-6.52-.21-6.5-3.56l.08-21.89c.01-3.29,3.62-5.3,6.43-3.58Z"
        />{' '}
      </g>
    </svg>
  );
};
export default Bos;
